import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdmin } from './AdminContext';
import VeritageLogo from '../components/VeritageLogo';
import WaveLines from '../components/WaveLines';
import { ArrowRight } from '../components/Icons';

export default function Login() {
  const { auth, login, logout } = useAdmin();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (auth.status === 'admin') return <Navigate to={location.state?.from || '/admin'} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try { await login(email, password); }
    catch (err) { setError(err.message || 'Sign in failed'); }
    finally { setBusy(false); }
  };

  return (
    <div className="cms-login">
      <WaveLines className="cms-login-waves" lines={30} amplitude={110} opacity={0.6} />
      <form className="cms-login-card" onSubmit={submit}>
        <VeritageLogo height={30} />
        <div>
          <div className="vt-eyebrow" style={{ marginBottom: 10 }}>Docs CMS</div>
          <h1>Sign in to edit the docs</h1>
          <p className="cms-muted">Use your Veritage dashboard account. Editing requires the admin role.</p>
        </div>
        {auth.status === 'forbidden' && (
          <div className="cms-alert">This account doesn't have docs admin access. <button type="button" className="cms-link" onClick={logout}>Use another account</button></div>
        )}
        {error && <div className="cms-alert">{error}</div>}
        <label className="cms-field">
          <span className="vt-eyebrow">Email</span>
          <input className="cms-input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label className="cms-field">
          <span className="vt-eyebrow">Password</span>
          <input className="cms-input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        <button className="vt-btn" type="submit" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
          <span className="vt-btn-arrow"><ArrowRight size={14} /></span>
        </button>
      </form>
    </div>
  );
}
